import { AdjustmentsMenuEntry } from '@/utilities/menu-entries/adjustments';
import { BaseMenuEntry } from '@/utilities/menu-entries/base-menu-entry';
import { CovariatesMenuEntry } from '@/utilities/menu-entries/covariates';
import { DosagesMenuEntry } from '@/utilities/menu-entries/dosages';
import { DrugsMenuEntry } from '@/utilities/menu-entries/drugs';
import { MeasuresMenuEntry } from '@/utilities/menu-entries/measures';
import { PatientMenuEntry } from '@/utilities/menu-entries/patient';
import { ReportsMenuEntry } from '@/utilities/menu-entries/reports';
import { TargetsMenuEntry } from '@/utilities/menu-entries/targets';
import { ValidationMenuEntry } from '@/utilities/menu-entries/validation';
import { createRouter, createWebHashHistory, RouteRecordRaw, RouterView } from 'vue-router';
import Home from '../views/Home.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { layout: 'full-screen' },
    },
    {
        // This "base" route will be used by the "NavBar" component to dynamically build the menu.
        // It is important to keep its name "app" here so the component can find it.
        path: '/app',
        name: 'app',
        redirect: { name: 'app.patient' },
        component: RouterView,  // A component is required, this one does nothing which is what we want
        children: [
            {
                path: 'patient',
                name: 'app.patient',
                meta: { entry: new PatientMenuEntry() },

                // route level code-splitting
                // this generates a separate chunk (patient.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "patient" */ '../views/01_patient/Index.vue'),
            },
            {
                path: 'drugs',
                name: 'app.drugs',
                meta: { entry: new DrugsMenuEntry() },
                component: () => import(/* webpackChunkName: "drugs" */ '../views/02_drugs/Index.vue'),
            },
            {
                path: 'dosages',
                name: 'app.dosages',
                meta: { entry: new DosagesMenuEntry() },
                component: () => import(/* webpackChunkName: "dosages" */ '../views/03_dosages/Index.vue'),
            },
            {
                path: 'covariates',
                name: 'app.covariates',
                meta: { entry: new CovariatesMenuEntry() },
                component: () => import(/* webpackChunkName: "covariates" */ '../views/04_covariates/Index.vue'),
            },
            {
                path: 'measures',
                name: 'app.measures',
                meta: { entry: new MeasuresMenuEntry() },
                component: () => import(/* webpackChunkName: "measures" */ '../views/05_measures/Index.vue'),
            },
            {
                path: 'targets',
                name: 'app.targets',
                meta: { entry: new TargetsMenuEntry() },
                component: () => import(/* webpackChunkName: "targets" */ '../views/06_targets/Index.vue'),
            },
            {
                path: 'adjustments',
                name: 'app.adjustments',
                meta: { entry: new AdjustmentsMenuEntry() },
                component: () => import(/* webpackChunkName: "adjustments" */ '../views/07_adjustments/Index.vue'),
            },
            {
                path: 'validation',
                name: 'app.validation',
                meta: { entry: new ValidationMenuEntry() },
                component: () => import(/* webpackChunkName: "validation" */ '../views/08_validation/Index.vue'),
            },
            {
                path: 'reports',
                name: 'app.reports',
                meta: { entry: new ReportsMenuEntry() },
                component: () => import(/* webpackChunkName: "reports" */ '../views/09_reports/Index.vue'),
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

// Prevent navigation to a disabled menu entry by redirecting to the app root
router.beforeEach((to) => {
    // If the target menu entry has no valid "entry" definition, allow the navigation
    if (!(to.meta.entry instanceof BaseMenuEntry)) {
        return true;
    }

    // If the menu entry is enabld, allow the navigation
    if (to.meta.entry.isEnabled()) {
        return true;
    }

    // Otherwise, redirect to the root of the app
    return {name: 'app'};
});

export default router;
